module.exports = __webpack_public_path__ + "img/sanxing.baf930b4.png";